import { render } from "./App.vue?vue&type=template&id=8ce371c2&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8ce371c2&scoped=true&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.12_vue@3.5.12_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ce371c2"]])

export default __exports__